export const ORDER_SHIPMENT_REPORT = 'order_shipment';
export const SCRAP_REPRINT_REPORT  = 'scrap_reprint';
export const FINISHING_EQUIPMENT_REPORT = 'finishing_equipment';
export const ORDER_COMPLETION_RATE_REPORT = 'order_completion_rate';
export const CUSTOMER_SERVICE_REPORT = 'customer_service';
export const ORDERS_REPORT = 'orders_report';
export const COMPLAINT_REPORT = 'complaint_report';
export const MATERIAL_USAGE_REPORT = 'material_usage_report';
export const EOM_REPORT = 'eom_report';

export const ORDERCHARTLABELS = [
    'Orders Shipped Earlier',
    'Orders Shipped',
    'Orders Not Yet Shipped',
    'Late Orders',
];

export const ORDERREPORTSCHARTLABELS = [
    'Orders Not Yet Shipped',
    'Orders Shipped Earlier',
    'Orders Shipped On Time',
    'Late Orders',
];

export const ORDERREPORTSCHARTCOLORS = [
    {
        backgroundColor: [
            'rgb(44,250,55)',
            'rgb(121,196,71)',
            'rgb(255,196,37)',
            'rgb(255,84,84)',
        ]
    },
];

export const JOBCHARTLABELS = [
    'Jobs Shipped Earlier',
    'Jobs Shipped',
    'Jobs Not Yet Shipped',
    'Late Jobs',
];

export const SHIPMENTCHARTLABELS = [
    'Shipments Shipped Earlier',
    'Shipments Shipped',
    'Shipments Not Yet Shipped',
    'Late Shipments',
];

export const ORDERCHARTCOLORS = [
    {
        backgroundColor: [
            'rgb(108,176,63)',
            'rgb(121,196,71)',
            'rgb(250,187,61)',
            'rgb(255,84,84)',
            'rgb(209,17,65)',
            'rgb(0,177,89)',
            'rgb(0,174,219)',
            'rgb(243,119,53)', 
            'rgb(255,196,37)',
            'rgb(238,64,53)',
            'rgb(253,244,152)',
            'rgb(243,119,54)',
            'rgb(123,192,67)',
            'rgb(3,146,207)',
            'rgb(0,171,169)',
            'rgb(255,0,151)',
            'rgb(162,0,255)',
            'rgb(27,161,226)',
            'rgb(240,150,9)',
            'rgb(255,190,79)',
            'rgb(107,210,219)',
            'rgb(14,167,181)',
            'rgb(12,69,125)',
            'rgb(232,112,42)'
        ]
    },
];

export let ORDERTOTALS = {
    lateJobs                : 0,
    lateOrders              : 0,
    qtyOfJobs               : 0,
    qtyOfJobsShipped        : 0,
    qtyOfJobsShippedEarly   : 0,
    qtyOfJobsShippedOnTime  : 0,
    qtyOfOrders             : 0,
    qtyOfOrdersShipped      : 0,
    qtyOfOrdersShippedEarly : 0,
    qtyOfOrderShippedOnTime : 0
};

export const EOMCHARTLABELS = [
    'UPS',
    'FedEx',
    'LTL'
];

export const EOMCARRIERCHARTCOLORS = [
    {
        backgroundColor: [
            'rgb(139, 69, 19)',  // UPS Brown
            'rgb(75, 0, 130)',   // FedEx Purple
            'rgb(50, 205, 50)',  // LTL Green
        ]
    },
];

export const EOMCOSTCHARTCOLORS = [
    {
        backgroundColor: [
            'rgb(255, 140, 0)',  // Orange for UPS costs
            'rgb(128, 0, 128)',  // Purple for FedEx costs
            'rgb(34, 139, 34)',  // Forest Green for LTL costs
        ]
    },
];

export const EOMBUSINESSUNITCHARTCOLORS = [
    {
        backgroundColor: [
            'rgb(35, 184, 230)',
            'rgb(255, 190, 12)',
            'rgb(229, 69, 29)',
        ]
    },
];


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/report-charts.ts